// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__QvniE","label":"Section_label__veYHi","contentWrap":"Section_contentWrap__2mu36","footer":"Section_footer__pHIj7","footerInner":"Section_footerInner__5_48Y"};